<template>
  <div class="sftp">
    <ak-integration-s-f-t-p-outbound
      v-if="service.outboundInitialised.value"
      :service="service"
    />
    <ak-integration-s-f-t-p-inbound
      v-if="service.inboundInitialised.value"
      :service="service"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import useSFTPSettings from './useSFTPSettings'

import IntegrationSFTPInbound from './inbound/IntegrationSFTPInbound.vue'
import IntegrationSFTPOutbound from './outbound/IntegrationSFTPOutbound.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPSettings',
  components: {
    [IntegrationSFTPInbound.name]: IntegrationSFTPInbound,
    [IntegrationSFTPOutbound.name]: IntegrationSFTPOutbound,
  },
  props: {
    activeAccountId: {
      required: true,
      type: String,
    },
    activeAgencyId: {
      required: true,
      type: String,
    },
    config: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const service = useSFTPSettings(
      props.activeAccountId,
      props.activeAgencyId,
      props.config,
    )
    service.init()
    return {
      service,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@akerolabs/akero-vue/src/scss/_settings.scss';

.sftp {
  display: grid;
  grid-template-columns: 1fr;
  gap: $spacing;
}
</style>
